class ProductBuyButtons extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // 複数（通常／固定）のボタンに対応
    this.button_containers = this.querySelectorAll(".product-buy-buttons--primary");
    this.button_texts = this.querySelectorAll(".product-buy-buttons--cta-text");
    this.forms = this.querySelectorAll(".product-buy-buttons--form");
    this.root = this.closest(`[data-product-id='${this.dataset.id}']`);
    this.select_input = this.querySelector(".product-buy-buttons--select");
    this.smart_button = this.querySelector(".product-buy-buttons--smart");
    this.primary_buttons = this.querySelectorAll(".product-buy-buttons--cta");

    // 既定文言を保存（先頭のものを基準）
    this.defaultText =
      (this.button_texts[0] && this.button_texts[0].innerText) ||
      (window.theme?.translations?.add_to_cart || "カートに追加");

    this.addToCartListener();
    this.updateViewListener();
  }

  setLoading(on) {
    this.button_containers.forEach((el) => el?.setAttribute("data-loading", on ? "true" : "false"));
    this.primary_buttons.forEach((btn) => {
      if (on) btn?.setAttribute("disabled", "true");
      else btn?.removeAttribute("disabled");
    });
  }

  showAddedFeedback() {
    const ADDED_TEXT = "カートに追加しました";
    this.button_texts.forEach((el) => {
      if (el) el.innerText = ADDED_TEXT;
    });
    clearTimeout(this._addedTimer);
    this._addedTimer = setTimeout(() => {
      this.button_texts.forEach((el) => {
        if (el) el.innerText = this.defaultText;
      });
    }, 2000);
  }

  addToCartListener() {
    // 複数フォーム（通常／固定）に対応
    this.forms.forEach((formEl) => {
      if (!formEl || typeof formEl.on !== "function") return;

      formEl.on("submit", async (e) => {
        e.preventDefault();
        e.stopPropagation();

        const form = e.target;
        const canAdd = window.theme?.utils?.getAvailableQuantity
          ? theme.utils.getAvailableQuantity(form)
          : true;
        if (!canAdd) return;

        this.setLoading(true);

        try {
          const ok = await window.theme?.cart?.addItem(form);
          this.setLoading(false);
          if (!ok) return;

          // 必要ならミニカートの数やヘッダー更新など
          if (window.theme?.cart?.updateAllHtml) {
            await theme.cart.updateAllHtml();
          }

          // モーダルは開かない（従来 addProductComplete 相当は無効化）
          this.addProductComplete();

          // 成功トースト（ボタン文言を書き換え → 2秒で戻す）
          this.showAddedFeedback();
        } catch (err) {
          this.setLoading(false);
          console.error("[ProductBuyButtons] add to cart failed:", err);
        }
      });
    });
  }

  // 以前はここでオフキャンバスを開いていたが無効化
  addProductComplete() {
    // 何もしない（モーダルを開かない）
  }

  updateViewListener() {
    window.on("theme:product:variantChanged", ({ detail: { section, variant } }) => {
      if (section !== this.root) return;

      const prev = this.select_input?.querySelector("option[selected]");
      if (prev) prev.removeAttribute("selected");

      if (variant && variant.available) {
        this.selectVariant(variant.id);
        this.updateView(true, true);
      } else if (variant && !variant.available) {
        self.selectVariant?.(variant.id);
        this.updateView(false, true);
      } else {
        this.updateView(false, false);
      }
    });
  }

  selectVariant(id) {
    const opt = this.select_input?.querySelector(`option[value='${id}']`);
    if (opt) opt.setAttribute("selected", "true");
  }

  updateView(isAvailable, hasVariant) {
    if (isAvailable) {
      this.primary_buttons.forEach((btn) => btn?.removeAttribute("disabled"));
      this.button_texts.forEach((el) => {
        if (el) el.innerText = window.theme?.translations?.add_to_cart || this.defaultText;
      });
      if (this.smart_button) this.smart_button.style.display = "block";
    } else {
      this.primary_buttons.forEach((btn) => btn?.setAttribute("disabled", "true"));
      if (this.smart_button) this.smart_button.style.display = "none";
      this.button_texts.forEach((el) => {
        if (!el) return;
        el.innerText = hasVariant
          ? (window.theme?.translations?.out_of_stock || "在庫切れ")
          : (window.theme?.translations?.unavailable || "利用不可");
      });
    }
  }
}

const productBuyButtonsEl = customElements.get("product-buy-buttons-root");
if (!productBuyButtonsEl) {
  customElements.define("product-buy-buttons-root", ProductBuyButtons);
}